import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Grid, Header } from 'semantic-ui-react';
import { DashboardConfigurationInterface } from '../../app/models/DashboardConfiguration';
import { defaultDashboardConfState } from '../../app/stores/dashboardConfiguration';
import { useStore } from '../../app/stores/store';
import DashboardLevel from './DashboardLevels';
import UnauthorizedMessage from '../UnauthorizedMessage';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
 
function DashboardConfiguration() {
  const { DashboardConfigurationStore, commonStore, dashboardStore } =
    useStore();
  const {
    dashboardLevelDetails,
    selectedFormLevel,
    deleteLevelItem,
    nextLevelGET,
  } = DashboardConfigurationStore;
 
  useEffect(() => {
    return () => {
      Object.keys(DashboardConfigurationStore).forEach((key: string) => {
        if ((defaultDashboardConfState as any)?.[key]) {
          (DashboardConfigurationStore as any)[key] = (
            defaultDashboardConfState as any
          )[key];
        }
      });
    };
    // eslint-disable-next-line
  }, []);
 
  useEffect(() => {
    DashboardConfigurationStore?.getLevelDetails();
    // eslint-disable-next-line
  }, []);
 
  const cardClickHandler = (
    id: string,
    level: number,
    index: number,
    _type: string,
    isDeleted?: boolean,
  ) => {
    let copy: {
      level: number;
      parentlevelId: string;
      selectedId: string;
      data: DashboardConfigurationInterface[];
    }[] = Object.assign([], dashboardLevelDetails || []);
 
    let name = copy?.[level]?.data?.[index]?.name || '';
 
    if (copy?.[level]?.data?.[index]) {
      copy[level].selectedId = copy[level].data[index]?.levelId || '';
    }
 
    if (isDeleted) {
      let deletedItem = [...copy[level].data];
      deletedItem.splice(index, 1);
      copy[level] = {
        ...copy[level],
        data: deletedItem,
      };
      let filter = copy.filter((data) => data.level <= level && data);
      DashboardConfigurationStore.dashboardLevelDetails = filter;
      deleteLevelItem(id, name);
    } else {
      let filter = copy.filter((data) => data.level <= level && data);
      nextLevelGET(id, level, filter);
    }
  };
 
  return (
    <>
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('DYDB') && <UnauthorizedMessage />}
      {commonStore.filterModeOne.includes('DYDB') && (
        <>
          <Header
            style={{ marginLeft: '20px' }}
            icon="cogs"
            size="huge"
            dividing
            as="h1"
            content={
              (userLanguage[0].Sidebar.M17 as any)?.[
                `${commonStore.language.key}`
              ]
            }
            sub
            color="grey"
          />
          <div
            style={{
              marginTop: '20px',
              marginRight: '10px',
              height: '85vh',
            }}
          >
            <Grid style={{ height: '100%', alignItems: 'center', margin: 0 }}>
              {dashboardLevelDetails?.map(
                (data, index) => (
                  <DashboardLevel
                    levelDetails={data}
                    parentIndex={index}
                    isForm={data.level === selectedFormLevel}
                    cardClickHandler={(
                      id: string,
                      index: number,
                      type: string,
                      isDeleted?: boolean,
                    ) =>
                      cardClickHandler(id, data.level, index, type, isDeleted)
                    }
                  />
                ),
                // )
              )}
            </Grid>
          </div>
        </>
      )}
    </>
  );
}
 
export default observer(DashboardConfiguration);